import { carSearchType } from '../constants/Enums';
import { carBrandMap } from '../constants/BrandMaps';
import { formatCurrency } from './currency.utils';

export const mapCarShipCodeCategory = (carTypeList) => {
  if (!carTypeList) {
    return carTypeList;
  }

  return carTypeList.reduce((acum, current) => {
    acum[current.CarCategory] = current.CarShipCodeCategory;
    return acum;
  }, {});
};

export const getFilterListByType = (results, carShipCode, currency, currencyCulture) => {
  if (!results || !carShipCode) {
    return null;
  }

  const res = results.reduce((acum, current) => {
    if (!acum[current.Class] || acum[current.Class] > current.MinimumfarePerDay) {
      acum[current.Class] = current.MinimumfarePerDay;
    }

    return acum;
  }, {});

  if (Object.keys(carShipCode).length >= 3) {
    while (Object.keys(res).length < 3) {
      const key = Object.keys(carShipCode).find((c) => !res[c]);
      res[key] = Infinity;
    }
  }

  let response = Object.entries(res)
    .map(([key, value]) => ({
      label: value === Infinity ? 'None' : formatCurrency(value, currency, currencyCulture),
      value: key,
      key: key,
      codeShip: carShipCode[key],
    }))
    .sort((a, b) => (a.codeShip > b.codeShip ? 1 : -1));

  if (Object.keys(res).length > 3) {
    response = response.slice(0, 3);
  }

  const minPrice = Math.min(...Object.values(res));

  response.unshift({
    label: minPrice === Infinity ? 'None' : formatCurrency(minPrice, currency, currencyCulture),
    value: 'ALL',
    key: 'All',
  });

  return response;
};

export const getCarsFromCarResult = (carSearchResults) => {
  const Cars = carSearchResults?.Cars?.map((car) => {
    if (car.OutSidePolicyException) {
      car.reasonCode = car.OutSidePolicyException.ReasonCode;
      car.reasonDescription = car.OutSidePolicyException.ReasonDescription;
      car.policyKey = car.OutSidePolicyException.PolicyKey;
      car.approverEmailAddress = car.OutSidePolicyException.ApproverEmailAddress;
    }

    return car;
  });

  return Cars;
};

export const getFilterBySearchType = (results) => {
  if (!results || !results.AirportCarMatrix || !results.CityCarMatrix) {
    return {};
  }
  const res = [];

  const minPriceCity = Math.min(...results.CityCarMatrix.map((c) => c.LowestPrice));
  const minPriceAirport = Math.min(...results.AirportCarMatrix.map((a) => a.LowestPrice));

  if (!isNaN(minPriceCity) && minPriceCity !== Infinity) {
    res.push({
      ...carBrandMap.city,
      brand: 'City',
      price: minPriceCity,
    });
  }
  if (!isNaN(minPriceAirport) && minPriceAirport !== Infinity) {
    res.push({
      ...carBrandMap.airport,
      brand: 'Airport',
      price: minPriceAirport,
    });
  }

  if (res.length > 0) {
    return res;
  } else {
    return null;
  }
};

const reduceCarType = (res, car) => {
  res[car.CarCategory] = {
    name: car.CarCategory,
    price: car.LowestPrice,
    checked: true,
  };
  return res;
};

export const getFilterByDetails = (results, type) => {
  if (!results || !results.CarMatrix) {
    return null;
  }
  const categoryItems = {};
  const companyItems = {};

  if (type === carSearchType.AIRPORT && results.AirportCarTypeList) {
    results.AirportCarTypeList.reduce(reduceCarType, categoryItems);
  } else if (type === carSearchType.CITY && results.CityCarTypeList) {
    results.CityCarTypeList.reduce(reduceCarType, categoryItems);
  }

  results.CarMatrix.filter((car) => car.RequestType === type).reduce((res, car) => {
    res[car.VendorCode] = {
      name: car.VendorName,
      price: car.LowestPrice,
      checked: true,
    };
    return res;
  }, companyItems);

  return {
    company: companyItems,
    category: categoryItems,
  };
};

/**
 * Function to add "Or Similar" Text to the end of the car name
 */
export const addTextToCarName = (text) => {
  if (!text || text.toLowerCase().includes('or similar')) {
    return text;
  }

  return text + ' Or Similar';
};
